import type { SagaIterator } from 'redux-saga';
import { all, takeLatest } from 'redux-saga/effects';
import { getRoutineSaga } from '../common/utils/new-sagas.js';
import { queryAdmin } from '../graphql-client.js';
import { getContentUsage, getPreviewRoutes } from './actions.js';
import { GET_CONTENT_USAGE_QUERY, GET_PREVIEW_ROUTES } from './api.js';

export default function* root(): SagaIterator {
  yield all([
    takeLatest(getContentUsage.requested, getRoutineSaga(getContentUsage, queryAdmin(GET_CONTENT_USAGE_QUERY))),
    takeLatest(getPreviewRoutes.requested, getRoutineSaga(getPreviewRoutes, queryAdmin(GET_PREVIEW_ROUTES)))
  ]);
}
